import { toast } from 'react-toastify';

export const createContificoClientIfNotExists = async ({
    docId,
    taxDocId,
    type,
    name,
    isForeigner,
    isClient,
    email,
    getContificoCtfPerson,
    createContificoClient,
}) => {
    try {
        const normalizedDocId = (docId || '').trim();
        const normalizedTaxDocId = (taxDocId || '').trim();
        const cedula =
            type === 'N' && normalizedDocId.length === 13
                ? normalizedDocId.slice(0, 10)
                : normalizedDocId;

        const cPerson = await getContificoCtfPerson({ docId: docId || taxDocId }).unwrap();

        if (!Array.isArray(cPerson) || !cPerson[0]) {
            await createContificoClient({
                tipo: type,
                nombre_comercial: null,
                telefonos: '',
                ruc: normalizedTaxDocId,
                razon_social: name,
                direccion: '',
                es_extranjero: isForeigner,
                porcentaje_descuento: '0',
                es_cliente: isClient,
                es_empleado: false,
                email,
                cedula,
                es_vendedor: false,
                adicional1_cliente: null,
                adicional2_cliente: null,
                adicional3_cliente: null,
                adicional4_cliente: null,
                adicional1_proveedor: null,
                adicional2_proveedor: null,
                adicional3_proveedor: null,
                adicional4_proveedor: null,
            }).unwrap();
        }

        return true; // ✅ Successfully created or already exists
    } catch (contificoError) {
        const code = contificoError?.data?.cod_error;
        const message = contificoError?.data?.mensaje || contificoError?.data?.message || '';

        if (code === 1501 || message.includes('Persona ya existe')) {
            return true;
        }

        toast.error(
            message ||
                contificoError.error ||
                'Error al crear cliente en Contifico, por favor contáctese con los administradores'
        );
        return false;
    }
};

export const fillFromContifico = (
    cPerson,
    setName,
    setEmail,
    setType,
    setTaxDocId,
    setIsForeigner,
    setIsClient,
    setPriceAssigned
) => {
    setName(cPerson[0].nombre_comercial || cPerson[0].razon_social);
    setEmail(cPerson[0].email);
    setType(cPerson[0].tipo);
    cPerson[0].ruc && setTaxDocId(cPerson[0].ruc);
    cPerson[0].es_extranjero && setIsForeigner(cPerson[0].es_extranjero);
    if (cPerson[0].es_cliente) {
        setIsClient(cPerson[0].es_cliente);
        setPriceAssigned(cPerson[0].pvp_default);
    }
};
